import React, {PureComponent} from 'react'
import Modal from 'react-modal'
import styled from 'styled-components'
import { BLUE,  WHITE } from '../colors'
import TextInput from './textInput'

const StyledModal = styled.div`
    background:${BLUE};
    color:${WHITE};
    max-width:480px;
    min-width:480px;
    margin:0 auto;
    .modal-header{
        display:flex;
        padding:10px 20px;
        flow-direction:row;
        align-items:center;
        h3{
            color:${WHITE};
        }
        .close-modal{
            margin-left:auto;
            cursor:pointer;
        }
        border-bottom:1px solid rgba(255,255,255,0.2);
    }
    .modal-content{
        padding:20px;
        display:flex;
        flex-direction:column;
        label{
            color:${WHITE};
            opacity:0.75;
            display:block;
            font-size:15px;
            padding-bottom:5px;
        }
        input{
            
        }
        button{
            margin-left:auto;
        }
        .modal-section{
            margin: 20px 0;
            display:flex;
            flex-direction:column;
        }
    }
`
const MODAL_STYLE = {
    overlay:{
        background:'rgba(44, 56, 71,0.8)'
    },
    content: {
        padding:0,
        border:0,
        background:'none',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
}

export class ModalInput extends PureComponent{
    onChange=(event)=>{
        let value = event.target.value
        const {onChange, field} = this.props
        if(onChange){
            onChange({key:field,value})
        }
    }
    render(){
        const {value = '', label, type ='text'} = this.props
        return (<div className="modal-section">
            <label>{label}</label>
            <TextInput type={type} value={value} onChange={this.onChange}  />
        </div>)
    }
}

export default class BaseModal extends PureComponent{

    render(){
        const {isOpen, onRequestClose} = this.props
        return (<Modal style={MODAL_STYLE} shouldCloseOnOverlayClick={true} isOpen={isOpen} onRequestClose={onRequestClose}>
            <StyledModal>
                {this.props.children}
            </StyledModal>
        </Modal>)
    }

}


// WEBPACK FOOTER //
// ./src/components/ui/modal.js